import React from 'react';
import SiteListView from '../../SiteListView';

const DefaultSiteType = ({ sitesReady, realm }) => (
  <SiteListView
    sitesReady={sitesReady}
    realm={realm}
  />
);

export default DefaultSiteType;
